import { mapState, mapGetters } from 'vuex'
import Mousetrap from 'utils/mousetrap'
import bus from 'src/eventbus'

export default {
  data: () => ({
    viewSlot: null
  }),
  computed: {
    ...mapState({
      screenType: state => state.views.type,
      activeSlot: state => state.views.active
    }),
    ...mapGetters(['hasTradeRequest']),
    mainNav() {
      return this.$refs.mainNav.menuList
    }
  },
  mounted() {
    Mousetrap.bindGlobal(
      ['mod+1', 'mod+2', 'mod+3', 'mod+4', 'mod+5', 'mod+6', 'mod+7'],
      this.getMenu
    )
    Mousetrap.bindGlobal({
      'mod+l': this.setWatch,
      'mod+b': e => {
        this.getTrade(e, 'buy')
      },
      'mod+s': e => {
        this.getTrade(e, 'sell')
      },
      tab: (e, combo) => this.tabCheck(e, combo),
      'shift+tab': (e, combo) => this.tabCheck(e, combo),
      up: (e, combo) => this.tabCheck(e, combo),
      down: (e, combo) => this.tabCheck(e, combo),
      left: (e, combo) => this.tabCheck(e, combo),
      right: (e, combo) => this.tabCheck(e, combo)
    })
    document.addEventListener('keydown', this.keyHandler)
  },
  methods: {
    getMenu(e) {
      e.preventDefault()
      const num = parseInt(e.key)
      const toPath = this.mainNav[num - 1].to
      this.$router.push(toPath)
      return false
    },
    getTrade(e, type) {
      e.preventDefault()
      if (this.screenType === 1) {
        const getType = document.querySelector('.' + type)
        if (getType) {
          getType.click()
          if (getType.disabled !== true && this.hasTradeRequest) {
            Mousetrap.unbind(
              ['tab', 'shift+tab', 'up', 'down', 'left', 'right'],
              'keydown'
            )
          }
        }
      } else {
        const views = document.querySelectorAll('.view-slot')[this.activeSlot]
        const btn = views.querySelector('.' + type)
        if (btn) {
          btn.click()
          if (btn.disabled !== true && this.hasTradeRequest) {
            Mousetrap.unbind(
              ['tab', 'shift+tab', 'up', 'down', 'left', 'right'],
              'keydown'
            )
          }
        }
      }
      return false
    },
    setWatch(e) {
      e.preventDefault()
      let active = null
      const watchStars = document.querySelectorAll('.watchlist-toggle')
      if (this.screenType === 1) {
        active = 0
      } else {
        active = this.activeSlot
      }
      const getSlot = watchStars[active]
      if (getSlot) getSlot.click()
      return false
    },
    closeModal() {
      const modalSum = document.querySelectorAll('.escCloseTab').length
      if (modalSum > 1 || modalSum < 0) return false
      let btn = ''
      if (this.hasTradeRequest) {
        const domForm = document.querySelector('.hideTradeForm')
        const domWarn = document.querySelector('.tradeWarning')
        btn = domWarn || domForm
      } else {
        btn = document.querySelector('.escCloseTab')
      }
      if (btn) btn.click()
      return false
    },
    tabCheck(e, combo) {
      e.preventDefault()
      if (this.screenType === 1) {
        bus.emit(bus.$events.CHECK_TAB, e, combo)
      }
      if (this.screenType !== 1 && !e.shiftKey) {
        this.$root.$emit('multCheckTab')
      }
      return false
    },
    keyHandler(e) {
      const keycode = e.keyCode || e.which
      const ctrl = e.ctrlKey || e.metaKey
      const shift = e.shiftKey
      const tab = keycode === 9
      const esc = keycode === 27
      const direction = keycode >= 37 && keycode <= 40
      const inputBox = e.target.nodeName === 'INPUT'
      const selectBox = e.target.nodeName === 'SELECT'
      const textBox = e.target.nodeName === 'TEXTAREA'
      const divBox = e.target.nodeName === 'DIV'
      const isA2Z = keycode >= 65 && keycode <= 90
      const isNumberKey =
        (keycode <= 105 && keycode >= 96) || (keycode <= 57 && keycode >= 48)
      // ctrl+shift+ || ctrl+alt+
      if (e.altKey && tab) return false
      if (e.code === 'Enter') return false
      if (ctrl && (shift || e.altKey)) return false
      if (ctrl && keycode !== 70) return false
      if (tab || (shift && tab) || direction) return false
      if (esc) {
        e.preventDefault()
        if (document.activeElement === document.querySelector('#searchInput')) {
          return false
        }
        this.closeModal()
        return false
      }
      if (inputBox || selectBox) return false

      if (
        !divBox &&
        !inputBox &&
        !textBox &&
        !selectBox &&
        !shift &&
        (isA2Z || isNumberKey)
      ) {
        e.preventDefault()
        if (this.hasTradeRequest) return false
        if (this.screenType === 1) {
          const isQuotePage = /^\/quote/.test(this.$route.path)
          if (isQuotePage && this.inApp) {
            bus.emit(bus.$events.DIRECT_INPUT, e.key)
          }
        } else {
          const views = document.querySelectorAll('.view-slot')[this.activeSlot]
          if (ctrl) {
            views.querySelector('input').click()
          } else {
            views.querySelector('input').click()
            this.$root.$emit('multInputDirectly', keycode)
          }
        }
        return false
      }
      return false
    }
  },
  watch: {
    hasTradeRequest(has) {
      if (!has) {
        Mousetrap.unbind(
          ['up', 'down', 'left', 'right', 'tab', 'shift+tab'],
          'keydown'
        )
        Mousetrap.bindGlobal(
          ['tab', 'shift+tab', 'up', 'down', 'left', 'right'],
          this.tabCheck
        )
      }
    }
  }
}
